import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Poppins",

    button: {
      textTransform: "none", // Removes the default uppercase transformation
      fontSize: 17,
    },
    h1: {
      color: "black",
      fontSize: 32,
      fontFamily: "Poppins",
      fontWeight: "700",
      marginBottom: "0.5rem",
    },
    h2: {
      fontSize: 24,
      fontWeight: "700",
      lineHeight: "34px",
      letterSpacing: "0.09px",
      wordWrap: "break-word",
    },
    h3: {
      fontFamily: "Poppins",
      fontSize: 22,
      fontWeight: "600",
      lineHeight: "30px",
      letterSpacing: "0.081px",
    },
    h4: {
      fontFamily: "Poppins",
      fontSize: 20,
      fontWeight: "600",
      lineHeight: "26px",
      letterSpacing: "0.074px",
    },
    h5: {
      fontFamily: "Poppins",
      fontSize: 18,
      fontWeight: "500",
      lineHeight: "39px",
      letterSpacing: "0.06px",
    },
    body1: {
      color: "black",
      fontFamily: "Poppins",
      fontSize: 17,
      fontWeight: "400",
      lineHeight: "25.50px",
      letterSpacing: "0.35px",
      wordWrap: "break-word",
    },
    body2: {
      fontFamily: "Poppins",
      fontSize: 15,
      fontWeight: "400",
      lineHeight: "22.50px",
      letterSpacing: "0.27px",
      wordWrap: "break-word",
    },
    caption: {
      fontSize: 13,
      fontFamily: "Poppins",
      fontWeight: "400",
      lineHeight: "18.50px",
      letterSpacing: "0.20px",
    },
  },
  palette: {
    primary: {
      main: "#328734",
    },
    secondary: {
      main: "#f50057",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "black", // Black border
              borderThickness: 2,
            },
            "&:hover fieldset": {
              borderColor: "black", // Black border on hover
              borderThickness: 2,
            },
            "&.Mui-focused fieldset": {
              borderColor: "black", // Black border on focus
              borderThickness: 2,
            },
            "& input": {
              color: "black", // Black text color
              borderThickness: 2,
            },
          },
          "& .MuiInputLabel-root": {
            color: "black", // Initial label color
            "&.Mui-focused": {
              color: "black", // Label color when focused
            },
            "&.MuiInputLabel-shrink": {
              color: "black", // Label color when there is text
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "black",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
  },
});
